import { useMemo, useState } from 'react';
import { TreeItemType } from '@/Components/TreeView/TreeView';
import { Pair } from '@/Types';

// Logistic type of product tree view options for form inputs
export function useLogisticTypesTreeViewOptions(allTypes: Pair<number>[], defaultValues?: number[]) {
  const [needToReset, setNeedToReset] = useState(false);

  const typesTreeViewItems = useMemo<TreeItemType<number>[]>(() => {
    setNeedToReset(false);

    return allTypes.map((item) => ({
      ...item,
      expanded: true,
      selected: Boolean(defaultValues?.includes(item.key)),
    }));
  }, [allTypes, needToReset, defaultValues]);

  return {
    typesTreeViewItems,
    setNeedToReset,
  };
}
